const AwardCategory = {
  PriceLOCQ: "pricelocq",
  ManualAtStation: "manual-at-station",
};

export default AwardCategory;
